import { Component, OnInit } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { privacyUrl, termsUrl } from 'src/environments/environment';

@Component({
  selector: 'app-declaration',
  templateUrl: './declaration.component.html',
  styleUrls: ['./declaration.component.scss'],
})
export class DeclarationComponent implements OnInit {
  termsUrl = termsUrl
  privacyUrl = privacyUrl
  constructor() { }

  ngOnInit() {}

  openExternalLink(link: string) {
    Browser.open({ url: link });
  }
}
